import ReadMore from "@stimulus-components/read-more"

export class Controller extends ReadMore {
  static targets = ["toggleButton", "content"]
  connect() {
    super.connect()
    this.shouldHideButton()
  }

  toggle(_event) {
    super.toggle(_event)
    this.contentTarget.classList.toggle("overflow-scroll")

    // Autoscroll to top-left when collapsing
    if (!this.contentTarget.classList.contains("overflow-scroll")) {
      this.contentTarget.scrollLeft = 0
      this.contentTarget.scrollTop = 0
    }
  }

  shouldHideButton() {
    if (this.isOverflowing(this.contentTarget)) {
      this.buttonTarget.classList.remove("hidden")
    } else {
      if (!this.open) {
        this.toggleButtonTarget.classList.add("hidden")
      }
    }
  }

  isOverflowing(e) {
    return e.offsetWidth + e.offsetHeight < e.scrollWidth + e.scrollHeight
  }
}
